module.exports = __webpack_public_path__ + "static/media/nitesh.f68c63a3.jpg";